// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"967b48d7","453":"d596afa0"}[chunkId] + ".chunk.js";
};